import { useTranslation } from 'react-i18next';

export default function TrustSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4 mb-12 md:mb-16">
          <div>
            <span className="inline-block text-xs font-medium text-accent-500 uppercase tracking-widest mb-3">
              Trust
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
              {t('trust.title')}
              <br />
              {t('trust.title2')}
            </h2>
          </div>
          <p className="text-sm md:text-base text-foreground-600 max-w-md">
            {t('trust.desc')}
          </p>
        </div>

        {/* Feature cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Card 1 */}
          <div className="bg-background-100 rounded-2xl p-8 md:p-10 hover:bg-background-200/70 transition-colors cursor-default">
            <div className="w-14 h-14 rounded-2xl bg-accent-100/70 flex items-center justify-center mb-6">
              <i className="ri-shield-check-line text-2xl text-accent-600"></i>
            </div>
            <h3 className="font-heading text-xl font-semibold text-foreground-950 mb-3">
              {t('trust.card1.title')}
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {t('trust.card1.desc')}
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-background-100 rounded-2xl p-8 md:p-10 hover:bg-background-200/70 transition-colors cursor-default">
            <div className="w-14 h-14 rounded-2xl bg-secondary-100/80 flex items-center justify-center mb-6">
              <i className="ri-truck-line text-2xl text-secondary-600"></i>
            </div>
            <h3 className="font-heading text-xl font-semibold text-foreground-950 mb-3">
              {t('trust.card2.title')}
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {t('trust.card2.desc')}
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-background-100 rounded-2xl p-8 md:p-10 hover:bg-background-200/70 transition-colors cursor-default">
            <div className="w-14 h-14 rounded-2xl bg-primary-100/60 flex items-center justify-center mb-6">
              <i className="ri-star-line text-2xl text-primary-500"></i>
            </div>
            <h3 className="font-heading text-xl font-semibold text-foreground-950 mb-3">
              {t('trust.card3.title')}
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {t('trust.card3.desc')}
            </p>
          </div>
        </div>

        {/* Stats */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6">
          <div className="text-center p-6">
            <div className="font-heading text-3xl md:text-4xl font-bold text-accent-600">{t('stats.spreadsheets')}</div>
            <div className="text-sm text-foreground-500 mt-1">{t('stats.spreadsheets.label')}</div>
          </div>
          <div className="text-center p-6">
            <div className="font-heading text-3xl md:text-4xl font-bold text-accent-600">{t('stats.users')}</div>
            <div className="text-sm text-foreground-500 mt-1">{t('stats.users.label')}</div>
          </div>
          <div className="text-center p-6">
            <div className="font-heading text-3xl md:text-4xl font-bold text-accent-600">{t('stats.sellers')}</div>
            <div className="text-sm text-foreground-500 mt-1">{t('stats.sellers.label')}</div>
          </div>
          <div className="text-center p-6">
            <div className="font-heading text-3xl md:text-4xl font-bold text-accent-600">{t('stats.countries')}</div>
            <div className="text-sm text-foreground-500 mt-1">{t('stats.countries.label')}</div>
          </div>
        </div>
      </div>
    </section>
  );
}